(function () {
	// AP編集箇所
	// direction: vertical / slidesPerView: 1 / loop: true の構成で、
	// 各スライドのテキスト行数が異なる場合（SPで長文が2行折り返し等）に
	// 全スライドを最大高さに揃えるため .swiper 要素の高さを制御する。
	//
	// スライド自体の高さは base.css の
	//   .announcement-bar__message { height: 100% !important }
	// に委ね、.swiper 高さを決めれば .swiper-wrapper → 各 .swiper-slide と
	// 100% チェーンで自動で揃う設計にする。
	//
	// 計測は flex-row のままだとスライドがコンテンツ幅で伸びて長文が折り返さず
	// 1行高さで測られてしまうため、一時的に wrapper を flex-column、
	// スライド幅 100%、スライド高さ auto !important に切り替えてから計測する。
	// Web フォント/画像の読込完了およびリサイズ時にも追従する。
	const measureAndApplyHeight = (swiperEl) => {
		if (!swiperEl) return 0;
		const wrapperEl = swiperEl.querySelector(".swiper-wrapper");
		// ループクローンは除外して実スライドだけ計測
		const rawSlides = swiperEl.querySelectorAll(
			".swiper-slide:not(.swiper-slide-duplicate)"
		);
		if (!rawSlides.length) return 0;

		// 計測中の一時スタイルを退避
		const prevSwiperHeight = swiperEl.style.height;
		const prevSwiperHeightPriority = swiperEl.style.getPropertyPriority("height");
		const prevFlexDirection = wrapperEl ? wrapperEl.style.flexDirection : "";
		const prevSlideStyles = [];

		// .swiper 高さを解除（コンテンツ実寸で wrapper を広げるため）
		swiperEl.style.removeProperty("height");
		if (wrapperEl) {
			wrapperEl.style.flexDirection = "column";
		}
		rawSlides.forEach((s, i) => {
			prevSlideStyles[i] = {
				width: s.style.width,
				height: s.style.height,
				heightPriority: s.style.getPropertyPriority("height"),
			};
			s.style.width = "100%";
			// base.css の height: 100%!important を一時的に打ち消す
			s.style.setProperty("height", "auto", "important");
		});

		// 強制リフロー
		void swiperEl.offsetHeight;

		let maxH = 0;
		rawSlides.forEach((s) => {
			if (s.offsetHeight > maxH) maxH = s.offsetHeight;
		});

		// 一時スタイルを復元
		if (wrapperEl) {
			wrapperEl.style.flexDirection = prevFlexDirection;
		}
		rawSlides.forEach((s, i) => {
			const prev = prevSlideStyles[i];
			s.style.width = prev.width;
			if (prev.height) {
				s.style.setProperty("height", prev.height, prev.heightPriority);
			} else {
				s.style.removeProperty("height");
			}
		});

		if (maxH > 0) {
			swiperEl.style.setProperty("height", maxH + "px", "important");
		} else if (prevSwiperHeight) {
			swiperEl.style.setProperty(
				"height",
				prevSwiperHeight,
				prevSwiperHeightPriority
			);
		}
		return maxH;
	};

	const announcementSlider = () => {
		$(".section-announcement").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const box = $(this).find(".announcement-bar");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			let autoplayParm;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				};
			} else {
				autoplayParm = {};
			}
			const swiperEl = $(this).find(".swiper")[0];

			// 初期化前に .swiper 高さを確定
			measureAndApplyHeight(swiperEl);

			const announcementSwiper = new Swiper(swiperEl, {
				direction: "vertical",
				slidesPerView: "1",
				autoHeight: false,
				speed: speed,
				loop: true,
				...autoplayParm,
			});

			const refresh = () => {
				const h = measureAndApplyHeight(swiperEl);
				if (h > 0 && announcementSwiper && announcementSwiper.update) {
					announcementSwiper.update();
				}
			};

			// Web フォント反映後
			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(refresh).catch(() => {});
			}
			// 画像等の全リソース読込完了後
			if (document.readyState === "complete") {
				setTimeout(refresh, 0);
			} else {
				window.addEventListener("load", refresh, { once: true });
			}
			// 幅変動（リサイズ／オリエンテーション変更）
			let resizeTimer = null;
			window.addEventListener("resize", () => {
				if (resizeTimer) clearTimeout(resizeTimer);
				resizeTimer = setTimeout(refresh, 150);
			});
		});
	};
	// AP編集箇所ここまで

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
